<div class="row">
    <div class="mb-3">
        <input class="kt-hidden" id="input-file-id" type="file" accept="image/png,image/jpeg"
            (change)="fileChangeEvent($event)" #imageInput [multiple]="isMultiple" />
        <button type="button" mat-raised-button color="primary" (click)="imageInput.click()" class="text-dark">
            {{label}}
        </button>
    </div>
</div>
<hr />

<div class="kt-portlet__head-progress">
    <mat-progress-bar mode="indeterminate" *ngIf="showSpinner"></mat-progress-bar>
</div>
<div *ngIf="onlineImage" class="row">
    <img [src]="onlineImage" style="width: 20em;height: 20em;object-fit: contain;" />
</div>

<div class="row overflow-auto justify-content-between">
    <ng-container *ngFor="let item of multiImageChangedEvent;let i =index">

        <div class="col-6 d-flex flex-column mb-5">
            <div class="d-flex justify-content-center mb-3" style="column-gap: 25px;">

                <!-- <button *ngIf="showAction" mat-mini-fab color="primary" class="text-dark shadow"
                    (click)="onShowCroppedImage(i)" [matTooltip]="'Show Final Image'">
                    <mat-icon>image</mat-icon>
                </button> -->

                <button [disabled]="imagesList[i]?.isLoaded" *ngIf="showAction" mat-mini-fab color="primary"
                    class="text-dark shadow" (click)="uploadImage(i)"
                    [matTooltip]="imagesList[i]?.uploadLabel ?? 'upload'">
                    <mat-icon>publish</mat-icon>
                </button>
                <button *ngIf="showAction" mat-mini-fab color="warn" class="shadow" [matTooltip]="'Delete Image'"
                    (click)="onDeleteUploadedImage(i)">
                    <mat-icon>delete</mat-icon>
                </button>
                <button *ngIf="showPrimarySelect" class="shadow" [matTooltip]="'Set as Primary'" mat-mini-fab
                    color="light" (click)="setImageAsPrimary(i,imagesList[i]?.isPrimary)" [ngClass]="{
                    'text-primary':  imagesList[i]?.isPrimary == true,
                    'text-dark': imagesList[i]?.isPrimary == false}" style="background-color: #f3f3f3;">
                    <mat-icon>star</mat-icon>
                </button>
            </div>
            <!-- <button mat-button [matTooltip]="'Set as Primary'" class="col" (click)="setImageAsPrimary(i)"
                *ngIf="showPrimarySelect">
                <mat-icon [ngClass]="{
                                    'text-primary': imagesList[i]?.isPrimary == true,
                                    'text-dark': imagesList[i]?.isPrimary == false}">star</mat-icon>
            </button> -->
            <div class="d-flex justify-content-center mb-3">
                <img [src]="urlImages[i]" style="width: 200px;
                  height: 200px;">
            </div>

            <!-- <image-cropper style="margin:auto;height: 20em;width: 20em;background: none;" 
                [maintainAspectRatio]="false"    format="jpeg" (imageCropped)="imageCropped($event,i)"
                (imageLoaded)="imageLoaded($event)" (cropperReady)="cropperReady()" [imageFile]="item"
                (loadImageFailed)="loadImageFailed()">
            </image-cropper> -->

        </div>
        <!-- <mat-divider *ngIf="multiImageChangedEvent.length > 1" class="col-1" [vertical]="true"></mat-divider> -->

    </ng-container>
</div>
<div *ngIf="onlineImages" class="row mb-3">
    <ng-container *ngFor="let item of onlineImages;let i=index">
        <div class="d-flex flex-column">
            <div class="d-flex justify-content-center mb-3" style="column-gap: 10px;">
                <button *ngIf="showDeleteBtn" [matTooltip]="'Delete image'" mat-mini-fab color="warn"
                    (click)="onDeleteOnilneImage(i)">
                    <mat-icon>delete</mat-icon>
                </button>
                <button *ngIf="showPrimarySelect" [matTooltip]="'Set as Primary'" mat-mini-fab color="light"
                    (click)="onSetOnlineImageAsPrimary(i,item.isPrimary)" [ngClass]="{
                    'text-primary': item.isPrimary,
                    'text-dark':!item.isPrimary}" style="background-color: #f3f3f3;">
                    <mat-icon>star</mat-icon>
                </button>
            </div>
            <img [src]="item.image" class="mx-2" style="width: 20em;height: 20em;object-fit: contain;" />
        </div>
    </ng-container>
</div>